//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'SelectSearch',
  props: {
    // 搜索选项列表
    searchSelectList: {
      type: Array,
      default: [{
        label: '昵称',
        value: 'nickname'
      }, {
        label: '用户ID',
        value: 'uid'
      }, {
        label: '手机号',
        value: 'phone'
      }]
    },
    // 默认选中的搜索选项
    select: {
      type: String,
      default: 'nickname'
    },
    // 搜索框的标签名称
    searchName: {
      type: String,
      default: '用户搜索：'
    }
  },
  data: function data() {
    return {
      // 用户输入的搜索关键词
      keywords: '',
      // 当前选中的搜索选项
      prependSelect: this.select,
      // 搜索表单数据
      searchForm: {
        nickname: '',
        uid: '',
        phone: ''
      }
    };
  },
  methods: {
    // 处理搜索事件
    changeSearch: function changeSearch() {
      this.searchForm = {
        nickname: '',
        uid: '',
        phone: '',
        real_name: '',
        returner: ''
      };
      this.searchForm[this.prependSelect] = this.keywords;
      this.$emit('search', this.searchForm);
    },
    resetParmas: function resetParmas() {
      this.keywords = '';
      this.prependSelect = this.select;
      this.changeSearch();
    }
  }
};